import { FC } from 'react';

import Block from '../../../../../components/Block';
import Column from '../../../../../components/Column';

import { CampaignAdGroup } from '../../../../../types/Campaign';
import CampaignAdGroupAudienceTargetingCard from '../Card/CampaignAdGroupAudienceTargetingCard';
import CampaignAdGroupLocationTargetingCard from '../Card/CampaignAdGroupLocationTargetingCard';

interface CampaignAdGroupTargetingTabProps {
    campaignAdGroup: CampaignAdGroup;
}

const CampaignAdGroupTargetingTab: FC<CampaignAdGroupTargetingTabProps> = ({ campaignAdGroup }) => {
    return (
        <Block disableGutters px={3}>
            <Column gap={4}>
                <CampaignAdGroupAudienceTargetingCard campaignAdGroup={campaignAdGroup} />

                <CampaignAdGroupLocationTargetingCard campaignAdGroup={campaignAdGroup} />
            </Column>
        </Block>
    );
};

export default CampaignAdGroupTargetingTab;
